// extracted by mini-css-extract-plugin
export var alerts = "headerSurvey-module--alerts--PYhq7";
export var saveStyleButton = "headerSurvey-module--save-style-button--6ymDP";
export var surveyHeader = "headerSurvey-module--survey-header--YgHRi";
export var surveyLogo = "headerSurvey-module--survey-logo--XIXHI";